<template>
  <form-item
    v-if="isForm"
    :name="name"
    :prop="prop"
    :rules="rules"
    :label="label"
    :hasDesc="hasDesc"
    :descContent="getTransText(name,'desc')"
    >
    <el-input-number
      v-model.number="val"
      @input="onInput"
      class="form-item"
      :min="min"
      :max="max"
      >
    </el-input-number>
  </form-item>
  <el-table-column
    v-else
    :label="label"
    align="center"
    width="80"
    >
    <template slot-scope="scope">
      <span v-text="scope.row[dataName]"></span>
    </template>
  </el-table-column>
</template>

<script>

import { getTransText } from '@/utils/i18n'

export default {
  name: 'rank-field',
  props: {
    value: null,
    hasDesc: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    data: {
      type: String
    },
    prop: {
      type: String
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 9999
    },
    isForm: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      val: this.value,
      dataName: this.data || this.name
    }
  },
  computed: {
    rules () {
      return [{
        required: true,
        message: this.getTransText(this.name, 'error')
      }]
    },
    label () {
      return this.getTransText(this.name, 'label')
    }
  },
  methods: {
    getTransText,
    onInput () {
      this.$emit('input', this.val)
    }
  },
  watch: {
    value (newValue) {
      this.val = newValue
    }
  }
}
</script>
